module.exports = __webpack_public_path__ + "img/message-hover.2341e051.svg";